import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useAuth } from '@/features/auth/hooks/useAuth'
import { cn } from '@/shared/lib/cn'

/**
 * Enlace "ADMIN" del header global. Solo se renderiza si el user autenticado
 * tiene `role === 'ADMIN'` — invisible para el resto (sigilo del shell
 * `/admin/*`). Es solo un punto de entrada: las secciones (reportes, usuarios,
 * carteleras, cuentas de tienda, locales, stats, audit, crons) viven en el
 * `AdminSidebar` dentro de `/admin`, no duplicadas aquí.
 */
export function AdminMenu() {
  const { t } = useTranslation()
  const { user } = useAuth()

  if (!user || user.role !== 'ADMIN') return null

  return (
    <Link
      to="/admin"
      className={cn(
        'inline-flex items-center rounded-md px-3 py-2 uppercase tracking-wider transition-colors hover:bg-yellow/30 hover:text-red focus:outline-none focus-visible:ring-2 focus-visible:ring-blue',
      )}
    >
      {t('nav.admin')}
    </Link>
  )
}
